import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { BadgeBookModalComponent } from '../shared/badge-book-modal/badge-book-modal.component';
import { BadgesService } from '../../services/badges.service';
import { AuthService } from '../../services/auth.service';
import { GroupsService } from '../../services/groups.service';
import { LocalService } from '../../services/local.service';
import { SidenavService } from '../../services/sidenav.service';

@Component({
  selector: 'app-stats-badges',
  templateUrl: './stats-badges.component.html',
  styleUrls: ['./stats-badges.component.scss'],
  standalone: false,
})
export class StatsBadgesComponent implements OnInit {
  sidenav: MatSidenav;
  loggedUser: any;
  groups: Array<any> = [];
  groupSelected: string = 'general';
  badgesRanking: Array<any> = [];

  private fullRanking: Array<any> = [];

  constructor(
    private sidenavService: SidenavService,
    private authService: AuthService,
    private groupsService: GroupsService,
    private localService: LocalService,
    private badgesService: BadgesService,
    private bottomSheet: MatBottomSheet,
    private router: Router,
  ) {
    this.sidenav = this.sidenavService.getSidenav();
    this.loggedUser = this.authService.getUser();
  }

  async ngOnInit() {
    this.groups = await this.groupsService.getList();
    this.groupSelected =
      (await this.localService.getDataV2<string>('stgrsel')) || 'general';
    const rankingResponse = await this.badgesService.getRanking();
    this.fullRanking = this.badgesService.normalizeRankingResponse(rankingResponse);
    this.loadRanking();
  }

  toggleMenu() {
    this.sidenavService.toggle();
  }

  goBack() {
    this.router.navigate(['/stats']);
  }

  async selectGroup(groupId: string) {
    this.groupSelected = groupId;
    await this.localService.saveDataV2('stgrsel', this.groupSelected);
    this.loadRanking();
  }

  openBadgeBook(entry: any) {
    this.bottomSheet.open(BadgeBookModalComponent, {
      data: {
        badges: entry.badges,
        userName: entry.user?.name || entry.user?.email,
      },
      panelClass: 'badge-book-sheet',
    });
  }

  private loadRanking() {
    let ranking = this.fullRanking;

    if (this.groupSelected !== 'general') {
      ranking = ranking.filter((entry: any) =>
        entry.user?.groups?.includes(this.groupSelected),
      );
    }

    this.badgesRanking = ranking.sort((a: any, b: any) => {
      if (b.gold !== a.gold) return b.gold - a.gold;
      if (b.silver !== a.silver) return b.silver - a.silver;
      if (b.bronze !== a.bronze) return b.bronze - a.bronze;
      return b.total - a.total;
    });
  }
}
